interface UploadedFileProgressProps {
  name: string;
  progress: number;
}

export const UploadedFileProgress = ({ name, progress }: UploadedFileProgressProps) => {
  return (
    <div className="flex w-[200px] flex-row justify-between space-x-12 rounded-lg bg-white p-2 text-xs font-semibold shadow-lg">
      <div className="w-full space-y-1 truncate">
        <p className="truncate">{name}</p>
        <div className="flex flex-row space-x-2">
          <div className="h-3 w-full overflow-hidden rounded-full bg-gray-200">
            <div className={`h-full !bg-[#000] transition-all duration-300`} style={{ width: `${progress}%` }}></div>
          </div>
          <p>{progress.toFixed(0)}%</p>
        </div>
      </div>
    </div>
  );
};
